import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["banner"];
import injectBanner from './inject-banner';
import getBannerData from './get-banner-data';
import injectMultipleBanners from './inject-multiple-banners';
export default function injectBannersToEntities(entities, _ref) {
  let {
      banner
    } = _ref,
    options = _objectWithoutProperties(_ref, _excluded);
  if (!entities.length) return [];
  const {
    repeat
  } = banner;
  const bannerData = getBannerData(banner, options);
  const entitiesWithBanner = repeat ? injectMultipleBanners(entities, bannerData) : injectBanner(entities, bannerData);
  return entitiesWithBanner;
}
//# sourceMappingURL=inject-banners-to-entities.js.map